import { useAuth0 } from '@auth0/auth0-react';
import { Button, Center, Stack, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { isStepUpInProgress } from 'shared/utils/redirect-to-step-up';

export type LoginLocationState = { returnTo?: string; isStepUp?: boolean };

export const MFA_FAILED_PARAM = 'mfa_failed';

const MFA_ACR_VALUES = 'http://schemas.openid.net/pape/policies/2007/06/multi-factor';

export function Login() {
  const { t } = useTranslation();
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();
  const history = useHistory();
  const { state, search } = useLocation<LoginLocationState | undefined>();
  const { returnTo } = state ?? {};
  const isStepUp = state?.isStepUp && isStepUpInProgress();
  const isMfaFailed = new URLSearchParams(search).has(MFA_FAILED_PARAM);

  useEffect(() => {
    if (isLoading || isMfaFailed) return;
    if (isAuthenticated && !isStepUp) {
      history.replace(returnTo ?? '/');
      return;
    }
    loginWithRedirect({
      appState: { returnTo },
      authorizationParams: isStepUp ? { acr_values: MFA_ACR_VALUES } : undefined,
    });
  }, [isLoading, isMfaFailed, isAuthenticated, isStepUp, loginWithRedirect, returnTo, history]);

  if (!isMfaFailed) return null;

  return (
    <Center h="100%" px="md">
      <Stack align="center" maw={480}>
        <Text ta="center">{t(i18nKeys.LOGIN.MFA_FAILED)}</Text>
        <Button onClick={() => loginWithRedirect()}>{t(i18nKeys.LOG_IN)}</Button>
      </Stack>
    </Center>
  );
}
